import React, { Component } from "react";
import "./Car.css";
import { Link } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { Redirect, withRouter } from "react-router-dom";
import { isMobile } from "react-device-detect";
import { selectCar } from "../../actions/cars";
import store from "../../store";

const imgdir = process.env.REACT_APP_IMG_FOLDER;

class Car extends Component {
  constructor(props) {
    super(props);
  }

  redirect = () => {
    store.dispatch(selectCar(this.props.car));
    localStorage.setItem("selectedCar", JSON.stringify(this.props.car));

    this.props.history.push("/carview");
  };

  render() {
    return (
      <div
        className={isMobile ? "CarCardMobile" : "CarCard"}
        onClick={this.redirect}
      >
        <div>
          <img src={imgdir + this.props.image} className="CarImage" />
        </div>
        <div className="CarModelNameCard">{this.props.modelName}</div>
        <div className="CarVersionCard">{this.props.version}</div>
        <div className="CarChasis">{this.props.chasis}</div>
        <div className="hr"></div>

        <div className={isMobile ? "CarPriceMobile" : "CarPrice"}>
          {this.props.price}
        </div>
        <div
          className={isMobile ? "ReservarButtonMobile" : "ReservarButton"}
          onClick={this.redirect}
        >
          <img
            src="/img/reservar.png"
            className={isMobile ? "ReservarImgMobile" : "ReservarImg"}
          />
        </div>
        <div
          className={
            isMobile ? "CarDescriptionSmallMobile" : "CarDescriptionSmall"
          }
        >
          <div className="CarTextSmall">
            {" "}
            <b>VERSIÓN:</b>
            {this.props.version2}
          </div>
          <div className="hr"></div>
          <div className="CarTextSmall">
            {" "}
            <b>MOTOR: </b>
            {this.props.motor}
          </div>
          <div className="hr"></div>
          <div>
            {" "}
            <b>TIPO: </b>
            {this.props.tipo}
          </div>
          <div className="hr"></div>

          <div>
            {" "}
            <b>COLOR: </b>
            {this.props.color}
          </div>
          <div className="hr"></div>
          <div>
            {" "}
            <b>MODELO: </b>
            {this.props.year}
          </div>
          <div className="hr"></div>
          <div>
            {" "}
            <b>TRANSMISION:</b> {this.props.gear}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Car);
